import { UpdateBanner as SharedUpdateBanner } from '@common/version/UpdateBanner';
import { useContentAreaRect } from 'layout/MainLayout/useContentAreaRect';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

/** Binds the shared new-version banner (`common-frontend`) to this app's router, messages and layout. */
export const UpdateBanner = () => {
    const { pathname } = useLocation();
    const contentRect = useContentAreaRect();

    return (
        <SharedUpdateBanner
            currentVersion={import.meta.env.VITE_GIT_COMMIT_HASH}
            pathname={pathname}
            message={<FormattedMessage id="version.notification.newVersionAvailable" />}
            refreshLabel={<FormattedMessage id="version.notification.refresh" />}
            // Pinned to the content area's measured box: its top is the header's bottom whatever
            // indicator bars sit above, and spanning its width centres the banner on the header's
            // axis rather than the viewport's. Floats over the page, under the header and every drawer.
            style={{
                zIndex: 'calc(var(--z-floating-ai-launcher) - 1)',
                ...(contentRect && {
                    top: contentRect.top + 8,
                    left: contentRect.left,
                    right: 'auto',
                    width: contentRect.width,
                }),
            }}
        />
    );
};
